import React, { useEffect, useContext, useState } from 'react';
import { number } from 'prop-types';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';
import { DEFAULT_BG_INDEX, HERO_IMAGES } from '../../utils/hero/constants';
import { LOHP_ROW, MAX_WIDTH_CONTAINER } from '../../utils/constants';
import SafeComponent from '../shared/SafeComponent';
import AppContext from '../context/AppContext';
import { HERO_ROTATION_INTERVAL } from './constants';
import Brand from './Campaign/Brand';
import Header from './Header';

import './style.scss';

const Hero = ({
    bgIndex
}) => {
    const [backgroundIndex, setBackgroundIndex] = useState(bgIndex);

    useEffect(() => {
        const changeBackground= () => {
            setBackgroundIndex((currentBackgroundIndex) => (
                currentBackgroundIndex + 1) % HERO_IMAGES.length
            );
        };

        const interval = setInterval(
            changeBackground,
            HERO_ROTATION_INTERVAL
        );

        return () => {
            if (interval) {
                clearInterval(interval);
            }
        };
    }, []);

    /* When the user scales down the screen, we don't want the bg color to change */
    const fixedBackground = () => {
        const fixedIndex = bgIndex < HERO_IMAGES.length
            ? bgIndex
            : DEFAULT_BG_INDEX;

        return HERO_IMAGES[fixedIndex].className;
    };

    const { displayBrandCampaign } = useContext(AppContext);

    const heroWrapperClasses = classNames(
        'hero-wrapper',
        'm-b-0',
        fixedBackground(),
        LOHP_ROW
    );

    const heroClasses = classNames(
        'hero',
        MAX_WIDTH_CONTAINER,
        {
            'display-brand-campaign': displayBrandCampaign
        },
    );

    return (
        <div className={heroWrapperClasses}>
            <div className="hero-backgrounds">
                {
                    HERO_IMAGES.map((heroImage, index) => {
                        const style = { opacity: index === backgroundIndex ? '1' : '0' };
                        const heroTitleKey = `logged_out_homepage.hero.${heroImage.title}`;
                        const sellerNameClasses = classNames(
                            'seller-name',
                            MAX_WIDTH_CONTAINER,
                            {
                                'show-stars': heroImage.showStars,
                                'with-brand-campaign': displayBrandCampaign
                            }
                        );

                        return (
                            <div className={heroImage.className} key={index} style={style}>
                                <div className={sellerNameClasses}>
                                    <p>{heroImage.name}, <b><I18n k={heroTitleKey}/></b></p>
                                </div>
                            </div>
                        );
                    })
                }
            </div>
            <div className={heroClasses}>
                <Header/>
                { displayBrandCampaign && <Brand className="hero-widget"/> }
            </div>
            { displayBrandCampaign && <div className="brand-campaign-bottom"/> }
        </div>
    );
};

Hero.defaultProps = {
    bgIndex: DEFAULT_BG_INDEX
};

Hero.propTypes = {
    bgIndex: number
};

export { Hero };
export default SafeComponent(Hero);
